module.exports = __webpack_public_path__ + "img/desert_cream.78a00585.png";